import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("G:/00_Project/4_Technomac-snc/layouts/admin.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("G:/00_Project/4_Technomac-snc/layouts/default.vue").then(m => m.default || m))
}